(function () {
  try {
    const root = document.getElementById("sp-registration-quote-root");
    if (!root) return;

    const API_ENDPOINT = root.dataset.apiEndpoint || "/apps/prudent-quote";
    const LIST_ID = root.dataset.klaviyoListId || "";
    const SITE_ID = root.dataset.klaviyoPubKey || ""; // Klaviyo public key (site ID)
    const qs = window.SP_REG_QR_PARAMS instanceof URLSearchParams
      ? window.SP_REG_QR_PARAMS
      : new URLSearchParams(location.search);

    const $ = (sel, ctx = document) => ctx.querySelector(sel);

    // --- analytics helper ---
    const dataLayer = (window.dataLayer = window.dataLayer || []);
    function track(event, payload = {}) {
      try { dataLayer.push({ event, ...payload }); } catch {}
      if (window.SP_REG_DEBUG) console.debug("[sp-reg][analytics]", event, payload);
    }

    function debounce(fn, wait = 200) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn(...args), wait);
      };
    }

    // "Dog~PureBreed~Beagle" -> "Beagle"
    function formatBreedLabel(breedString) {
      if (!breedString || typeof breedString !== "string") return "";
      const parts = breedString.split("~");
      return parts.length === 3 ? parts[2].trim() : breedString.trim();
    }
    // Map a human label like "Beagle" -> canonical "Dog~PureBreed~Beagle"
    function findCanonicalFromLabel(label, items) {
      const needle = (label || "").trim().toLowerCase();
      if (!needle) return "";
      const exact = items.find((full) => formatBreedLabel(full).toLowerCase() === needle);
      if (exact) return exact;
      const loose = items.find((full) => formatBreedLabel(full).toLowerCase().includes(needle));
      return loose || "";
    }

    function clearError(inputEl) {
      if (!inputEl) return;
      inputEl.setAttribute("aria-invalid", "false");
      inputEl.classList.remove("input--error");
      const group = inputEl.closest(".input-group") || inputEl.parentElement;
      if (!group) return;
      const overlay = group.querySelector(".sp-error");
      if (overlay) overlay.remove();
    }
    function showError(inputEl, text) {
      if (!inputEl) return;
      inputEl.setAttribute("aria-invalid", "true");
      inputEl.classList.add("input--error");
      const group = inputEl.closest(".input-group") || inputEl.parentElement;
      if (!group) return;
      let overlay = group.querySelector(".sp-error");
      if (overlay) overlay.remove();
      overlay = document.createElement("div");
      overlay.className = "sp-error";
      overlay.setAttribute("role", "alert");
      overlay.innerHTML = '<img class="sp-error__icon" alt="" src="https://cdn.shopify.com/s/files/1/0339/3110/0219/files/error-icon.svg?v=1761775488" />' +
                          '<span class="sp-error__text"></span>';
      overlay.querySelector(".sp-error__text").textContent = String(text);
      group.appendChild(overlay);
    }
    function clearAllErrors(formEl) {
      formEl.querySelectorAll(".message.message--error").forEach((n) => n.remove());
      formEl.querySelectorAll("[aria-invalid='true']").forEach((el) => {
        el.setAttribute("aria-invalid", "false");
        el.classList.remove("input--error");
      });
    }
    function isValidEmail(s) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(String(s || "").trim());
    }
    function isoDate(d) {
      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      return `${y}-${m}-${day}`;
    }

    function computeAgeStr(iso) {
      if (!iso) return "";
      var d = new Date(iso + "T00:00:00");
      if (isNaN(d.getTime())) return "";
      var now = new Date();
      var years = now.getFullYear() - d.getFullYear();
      var months = now.getMonth() - d.getMonth();
      var days = now.getDate() - d.getDate();
      if (days < 0) { months -= 1; }
      if (months < 0) { years -= 1; months += 12; }
      if (years < 1) {
        return months + (months === 1 ? " month old" : " months old");
      }
      var mm = months > 0 ? ", " + months + (months === 1 ? " month" : " months") : "";
      return years + (years === 1 ? " year" : " years") + mm + " old";
    }

    // Ensure "Mixed Breed - Small/Medium/Large" float to the top of lists (like Prudent)
    function prioritizeMixedBreeds(items) {
      if (!Array.isArray(items) || !items.length) return items || [];
      const wantedOrder = [
        { size: "small",  match: /small/i },
        { size: "medium", match: /medium/i },
        { size: "large",  match: /large/i },
      ];
      const isMixed = (label) => /mixed\s*breed/i.test(label);

      const picked = [];
      const rest = [];

      items.forEach((full) => {
        const label = formatBreedLabel(full);
        if (isMixed(label)) {
          const lower = label.toLowerCase();
          const slot = wantedOrder.findIndex(w => w.match.test(lower));
          if (slot >= 0) {
            if (!picked[slot]) picked[slot] = full;
          } else {
            rest.push(full);
          }
        } else {
          rest.push(full);
        }
      });

      const compactPicked = wantedOrder.map((_, i) => picked[i]).filter(Boolean);
      return [...compactPicked, ...rest];
    }

    function prioritizeDomesticCatBreeds(items) {
      if (!Array.isArray(items) || !items.length) return items || [];
      const targets = [
        'domestic shorthair','domestic mediumhair','domestic longhair'
      ];
      const picked = [];
      const rest = [];
      items.forEach((full)=>{
        const label = formatBreedLabel(full).toLowerCase();
        const idx = targets.indexOf(label);
        if (idx !== -1) { if (!picked[idx]) picked[idx]=full; }
        else { rest.push(full); }
      });
      const compact = targets.map((_,i)=>picked[i]).filter(Boolean);
      // avoid duplicates: remove any picked breeds from rest if they slipped in
      const setPicked = new Set(compact.map(String));
      const remaining = rest.filter(x=>!setPicked.has(String(x)));
      return [...compact, ...remaining];
    }


// ---------- render form ----------
    root.innerHTML = `
<div class="sp-card">
  <div class="sp-progress-container">
    <div class="sp-progress-bar" id="sp-progress-bar" style="width: 15%;"></div>
  </div>

  <h2 class="heading--primary" id="sp-form-title">Register Below</h2>
  <p class="sp-muted" id="sp-form-subtitle">Let us know a little about yourself!</p>

  <form id="sp-reg-form">
    <div class="sp-honeypot" aria-hidden="true">
      <label class="sr-only" for="sp-company">Company</label>
      <input type="text" id="sp-company" name="company" tabindex="-1" autocomplete="off">
    </div>

    <div id="sp-step-1">
      <div class="sp-row-2">
        <div class="input-group input-group--moving-label">
          <input class="input" type="text" id="sp-first-name" name="first_name" placeholder="First Name" required />
          <label class="label--primary" for="sp-first-name">First Name</label>
        </div>
        <div class="input-group input-group--moving-label">
          <input class="input" type="text" id="sp-last-name" name="last_name" placeholder="Last Name" required />
          <label class="label--primary" for="sp-last-name">Last Name</label>
        </div>
      </div>

      <div class="sp-row-2">
        <div class="input-group input-group--moving-label">
          <input class="input" type="email" id="sp-email" name="email" placeholder="Email" required />
          <label class="label--primary" for="sp-email">Email</label>
        </div>
        <div class="input-group input-group--moving-label">
          <input class="input" type="text" id="sp-zip" name="zip" placeholder="ZIP Code" inputmode="numeric" pattern="[0-9]{5}" maxlength="5" required />
          <label class="label--primary" for="sp-zip">ZIP Code</label>
        </div>
      </div>

      <div class="input-group" style="margin-top: 1.5rem;">
        <button class="btn btn--primary btn--full-mobile" id="sp-next-btn" type="button">Next Step</button>
      </div>
    </div>

    <div id="sp-step-2" style="display: none;">
      <div class="sp-row-2 sp-toggle-row">
        <div class="sp-toggle-group" data-target="#sp-species" role="group" aria-label="Species">
          <button type="button" class="sp-toggle" data-value="dog">
            <img alt="" src="https://cdn.shopify.com/s/files/1/0339/3110/0219/files/Dog_Icon_477f3e00-d687-49c5-ae60-6691606e4842.svg?v=1761749062" class="sp-toggle__icon" /> Dog
          </button>
          <button type="button" class="sp-toggle" data-value="cat">
            <img alt="" src="https://cdn.shopify.com/s/files/1/0339/3110/0219/files/Kitty_Icon_b0fb45ce-486d-4112-baf0-36dfd8f5ade3.svg?v=1761748734" class="sp-toggle__icon" /> Cat
          </button>
          <input type="hidden" id="sp-species" name="species" value="dog" />
        </div>
        <div class="sp-toggle-group" data-target="#sp-gender" role="group" aria-label="Gender">
          <button type="button" class="sp-toggle" data-value="M">
            <img alt="" src="https://cdn.shopify.com/s/files/1/0339/3110/0219/files/Male_Icon_03a55f44-5508-4659-97f1-d4e9ea7e4428.svg?v=1761748733" class="sp-toggle__icon" /> Male
          </button>
          <button type="button" class="sp-toggle" data-value="F">
            <img alt="" src="https://cdn.shopify.com/s/files/1/0339/3110/0219/files/Female_Icon_7114bdbb-e4a3-4475-af85-38607d78e243.svg?v=1761748733" class="sp-toggle__icon" /> Female
          </button>
          <input type="hidden" id="sp-gender" name="gender" value="" />
        </div>
      </div>

      <div class="sp-row-2">
        <div class="input-group input-group--moving-label">
          <input class="input" type="text" id="sp-pet-name" name="pet_name" placeholder="Pet Name" required />
          <label class="label--primary" for="sp-pet-name">Pet Name</label>
        </div>
        <div class="input-group input-group--moving-label">
          <input class="input" type="date" id="sp-dob" name="dob" placeholder="Pet Date of Birth" required />
          <label class="label--primary" for="sp-dob">Pet Date of Birth</label>
        </div>
      </div>

      <div class="input-group input-group--moving-label" id="sp-breed-wrapper">
        <input class="input" id="sp-breed" name="breed" placeholder="Pet Breed" list="sp-breed-list" autocomplete="off" required aria-expanded="false" />
        <span id="sp-breed-arrow"></span>
        <label class="label--primary" for="sp-breed">Pet Breed</label>
      </div>
      <input type="hidden" id="sp-breed-hidden" name="breed_code" value="" />

      <div class="input-group input-group--checkbox sp-consent-group">
        <input type="checkbox" id="sp-consent" name="consent" required />
        <label for="sp-consent">Yes! I'd love to get Snuggle Puppy updates, special offers, and tips for happier nights.</label>
      </div>

      <div class="sp-btn-group-step2">
        <button type="button" class="btn btn--secondary" id="sp-back-btn" style="flex: 1; padding: 0.8rem; background: #f8fafc; border: 1px solid #e2e8f0; color: #475569;">Back</button>
        <button class="btn btn--primary" id="sp-submit" type="submit" style="flex: 2;">Register Now</button>
      </div>
    </div>
  </form>

  <div id="sp-quote-results" class="sp-quote-results" role="status" aria-live="polite" aria-atomic="true"></div>
</div>
`;

    // ---------- toggle helpers ----------
    function initToggleGroups() {
      const groups = root.querySelectorAll(".sp-toggle-group");
      groups.forEach((group) => {
        const targetSel = group.getAttribute("data-target");
        const hidden = root.querySelector(targetSel);
        if (!hidden) return;

        function syncActive() {
          const val = hidden.value || "";
          group.querySelectorAll(".sp-toggle").forEach((btn) => {
            const active = btn.getAttribute("data-value") === val;
            btn.classList.toggle("is-active", active);
            btn.setAttribute("aria-pressed", active ? "true" : "false");
          });
        }

        group.addEventListener("click", (e) => {
          const btn = e.target.closest(".sp-toggle");
          if (!btn) return;
          e.preventDefault();
          const val = btn.getAttribute("data-value");
          if (hidden.value !== val) {
            hidden.value = val;
            hidden.dispatchEvent(new Event("change", { bubbles: true }));
            syncActive();
          }
        });

        // Initialize active state on load
        syncActive();
      });
    }

// ---------- query elements AFTER injection ----------
    initToggleGroups();

    const form = $("#sp-reg-form", root);
    const submitBtn = $("#sp-submit", root);
    const results = $("#sp-quote-results", root);
    const zipInput = $("#sp-zip", root);
    const speciesSelect = $("#sp-species", root);
    const breedInput = $("#sp-breed", root);
    const breedHidden = $("#sp-breed-hidden", root);
    const breedList = $("#sp-breed-list", root);
    const genderSelect = $("#sp-gender", root);
    const emailInput = $("#sp-email", root);
    const dobInput = $("#sp-dob", root);
    
    // Name and Consent elements
    const firstName = $("#sp-first-name", root);
    const lastName = $("#sp-last-name", root);
    const petName = $("#sp-pet-name", root);
    const consent = $("#sp-consent", root);

    // 2-Step DOM elements
    const nextBtn = $("#sp-next-btn", root);
    const backBtn = $("#sp-back-btn", root);
    const step1 = $("#sp-step-1", root);
    const step2 = $("#sp-step-2", root);
    const progressBar = $("#sp-progress-bar", root);
    const formSubtitle = $("#sp-form-subtitle", root);

    // ---------- 2-Step Form Logic ----------
    if (nextBtn) {
      nextBtn.addEventListener("click", () => {
        let firstInvalid = null;

        // Validate Step 1 fields before proceeding
        if (firstName && !firstName.value.trim()) { showError(firstName, "First name is required"); if (!firstInvalid) firstInvalid = firstName; }
        if (lastName && !lastName.value.trim()) { showError(lastName, "Last name is required"); if (!firstInvalid) firstInvalid = lastName; }
        if (emailInput) {
          const v = emailInput.value.trim();
          if (!isValidEmail(v)) { showError(emailInput, "Please enter a valid email address"); if (!firstInvalid) firstInvalid = emailInput; }
        }
        if (zipInput) {
          const z = (zipInput.value || "").replace(/\D/g, "");
          if (z.length !== 5) { showError(zipInput, "Please enter a valid 5-digit ZIP code"); if (!firstInvalid) firstInvalid = zipInput; }
        }

        if (firstInvalid) {
          firstInvalid.scrollIntoView({ behavior: "smooth", block: "center" });
          try { firstInvalid.focus({ preventScroll: true }); } catch {}
          return;
        }

        // Proceed to Step 2
        step1.style.display = "none";
        step2.style.display = "block";
        progressBar.style.width = "50%";
        formSubtitle.textContent = "We'd love to learn about your Snuggle Puppy's new buddy!";
      });
    }

    if (backBtn) {
      backBtn.addEventListener("click", () => {
        step2.style.display = "none";
        step1.style.display = "block";
        progressBar.style.width = "15%"; 
        formSubtitle.textContent = "Let us know a little about yourself!";
      });
    }

    // ---------- ARIA & Input Listeners ----------
    if (speciesSelect) speciesSelect.addEventListener('change', () => clearError(speciesSelect));
    if (genderSelect) genderSelect.addEventListener('change', () => clearError(genderSelect));

    // ARIA for custom combobox
    breedInput.setAttribute("role", "combobox");
    breedInput.setAttribute("aria-autocomplete", "list");
    breedInput.setAttribute("aria-controls", "sp-breed-dropdown");
    breedInput.setAttribute("aria-expanded", "false");

    // Disable native datalist dropdown to prevent double list
    if (breedInput) breedInput.removeAttribute("list");

    // ---- DOB range: max = today, min = today - 25 years
    if (dobInput) {
      const today = new Date();
      const min = new Date(today);
      min.setFullYear(today.getFullYear() - 25);
      dobInput.setAttribute("max", isoDate(today));
      dobInput.setAttribute("min", isoDate(min));
    }

    // --- iOS Safari date label tweak: keep label down until value exists
    if (dobInput) {
      const isIOS = /iP(hone|od|ad)/.test(navigator.platform)
        || (navigator.userAgent.includes('Mac') && 'ontouchend' in document);
      if (isIOS) {
        const dobLabel = root.querySelector('label[for="sp-dob"]');
        const syncDobLabel = () => {
          if (!dobLabel) return;
          dobLabel.classList.toggle('is-safari-date-empty', !dobInput.value);
        };
        syncDobLabel();
        dobInput.addEventListener('input', syncDobLabel);
        dobInput.addEventListener('change', syncDobLabel);
        dobInput.addEventListener('blur', syncDobLabel);
      }
    }

    if (!form) {
      console.error("[sp-reg] Form root not found—aborting init.");
      return;
    }

    // Analytics: form view
    track("reg_form_view", { widget: "product_registration" });
    let hasStarted = false;
    function markStarted() {
      if (!hasStarted) { hasStarted = true; track("reg_form_start"); }
    }

    // Ensure native pattern uses [0-9]{5}
    if (zipInput) {
      if (zipInput.getAttribute("pattern") !== "[0-9]{5}") {
        zipInput.setAttribute("pattern", "[0-9]{5}");
      }
      zipInput.setAttribute("inputmode", "numeric");
      zipInput.setAttribute("maxlength", "5");
      
      zipInput.addEventListener("input", () => {
        const digits = (zipInput.value || "").replace(/\D/g, "").slice(0, 5);
        if (zipInput.value !== digits) zipInput.value = digits;
        clearError(zipInput);
        markStarted();
      });
      zipInput.addEventListener("blur", () => {
        const v = (zipInput.value || "");
        if (v.length !== 5) showError(zipInput, "Please enter a valid 5-digit ZIP code");
      });
    }

    // Email format validation
    if (emailInput) {
      emailInput.setAttribute("inputmode", "email");
      emailInput.setAttribute("autocomplete", "email");
      emailInput.addEventListener("input", () => clearError(emailInput));
      emailInput.addEventListener("blur", () => {
       const v = emailInput.value.trim();
       if (v && !isValidEmail(v)) {
         showError(emailInput, "Please enter a valid email address");
       }
      });
    }

    // DOB is required; must be within last 25 years and not in the future
    if (dobInput) {
      const validateDob = () => {
        clearError(dobInput);
        const v = dobInput.value;
        if (!v) return; // allow empty
        const d = new Date(v + "T00:00:00");
        const min = new Date(dobInput.getAttribute("min"));
        const max = new Date(dobInput.getAttribute("max"));
        if (!(d instanceof Date) || isNaN(d.getTime()) || d < min || d > max) {
          showError(dobInput, "Please enter a valid date of birth");
        }
      };
      dobInput.addEventListener("input", () => clearError(dobInput));
      dobInput.addEventListener("blur", validateDob);
      dobInput.addEventListener("change", validateDob);
    }

    if (firstName) {
      firstName.addEventListener("input", () => clearError(firstName));
      firstName.addEventListener("blur", () => { if (!firstName.value.trim()) showError(firstName, "First name is required"); });
    }
    if (lastName) {
      lastName.addEventListener("input", () => clearError(lastName));
      lastName.addEventListener("blur", () => { if (!lastName.value.trim()) showError(lastName, "Last name is required"); });
    }
    if (petName) {
      petName.addEventListener("input", () => clearError(petName));
      petName.addEventListener("blur", () => { if (!petName.value.trim()) showError(petName, "Pet name is required"); });
    }
    if (consent) {
      consent.addEventListener("change", () => clearError(consent));
    }
    
// ---- ZIP: keep only 5 digits & basic validation ----
    if (zipInput) {
      zipInput.addEventListener("input", () => {
        const digits = (zipInput.value || "").replace(/\D/g, "").slice(0, 5);
        if (zipInput.value !== digits) zipInput.value = digits;
        clearError(zipInput);
        markStarted();
      });
      zipInput.addEventListener("blur", () => {
        const v = (zipInput.value || "");
        if (v.length !== 5) showError(zipInput, "Please enter a valid 5-digit ZIP code");
      });
    }

    // ---------- breeds ----------
    const cache = { breeds: {} };

    async function fetchBreeds(species) {
      try {
        if (cache.breeds[species]) return cache.breeds[species];
        const url = API_ENDPOINT + "/values/breeds?species=" + encodeURIComponent(species);
        console.debug("[sp-reg] fetching breeds:", url);
        const res = await fetch(url, { headers: { Accept: "application/json" } });
        if (!res.ok) {
          const t = await res.text();
          console.error("[sp-reg] breeds fetch failed:", res.status, t);
          return [];
        }
        const data = await res.json();
        const arr = Array.isArray(data) ? data : [];
        const dedup = Array.from(new Set(arr));
        dedup.sort((a, b) => {
          const la = formatBreedLabel(a).toLowerCase();
          const lb = formatBreedLabel(b).toLowerCase();
          return la.localeCompare(lb);
        });
        let list = prioritizeMixedBreeds(dedup);
        if (String(species).toLowerCase()==='cat') list = prioritizeDomesticCatBreeds(list);
        cache.breeds[species] = list;
        console.debug("[sp-reg] breeds loaded:", species, dedup.length);
        return cache.breeds[species];
      } catch (e) {
        console.error("[sp-reg] breeds fetch error:", e);
        return [];
      }
    }

    function filterBreeds(query, breeds) {
      const q = (query || "").trim().toLowerCase();
      if (!q) return breeds.slice(0, 150);
      const scored = breeds
        .map((full) => {
          const label = formatBreedLabel(full).toLowerCase();
          const starts = label.startsWith(q);
          const includes = !starts && label.includes(q);
          return { full, label, score: starts ? 0 : includes ? 1 : 2 };
        })
        .filter((x) => x.score < 2)
        .sort((a, b) => (a.score - b.score) || a.label.localeCompare(b.label))
        .slice(0, 150)
        .map((x) => x.full);
      return scored;
    }

    function htmlEscape(s) {
      return String(s)
        .replace(/&/g, "&amp;")
        .replace(/"/g, "&quot;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;");
    }

    function populateBreedOptions(items) {
      if (!breedList) return;
      breedList.innerHTML = items
        .map((full) => '<option value="' + htmlEscape(formatBreedLabel(full)) + '" data-full="' + htmlEscape(full) + '"></option>')
        .join("");
      console.debug("[sp-reg] datalist options:", breedList.options?.length || 0);
    }

    function syncHiddenBreed() {
      if (!breedInput || !breedHidden || !speciesSelect) return;
      const sp = speciesSelect.value || "dog";
      const items = cache.breeds[sp] || [];
      const canonical = findCanonicalFromLabel(breedInput.value, items);
      breedHidden.value = canonical || "";
      if (canonical) clearError(breedInput);
    }

    const refreshBreeds = debounce(async () => {
      const sp = speciesSelect.value || "dog";
      const all = await fetchBreeds(sp);
      populateBreedOptions(filterBreeds(breedInput.value, all));
      syncHiddenBreed();
    }, 150);

    // Fetch & populate on load, focus and input
    speciesSelect.addEventListener("change", async () => {
      breedInput.value = "";
      breedHidden.value = "";
      clearError(breedInput);
      await refreshBreeds();
    });

    
// ---- Custom dropdown for breed field ----
const breedDropdown = document.createElement("ul");
breedDropdown.id = "sp-breed-dropdown";
breedDropdown.className = "sp-dropdown hidden";
breedDropdown.setAttribute("role", "listbox");
document.body.appendChild(breedDropdown);

function positionBreedDropdown(anchorEl) {
  const rect = anchorEl.getBoundingClientRect();
  breedDropdown.style.left = (rect.left + window.scrollX) + "px";
  breedDropdown.style.top = rect.bottom + window.scrollY + "px";
  breedDropdown.style.width = rect.width + "px";
}

["scroll","resize"].forEach(evt => {
  window.addEventListener(evt, () => {
    if (breedDropdown.classList.contains("open")) {
      positionBreedDropdown(breedInput);
    }
  }, { passive: true });
});

function showBreedDropdown(items) {
  if (!Array.isArray(items) || !items.length) return hideBreedDropdown();
  breedDropdown.innerHTML = items.map((full) => {
    const label = formatBreedLabel(full);
    return '<li role="option" data-full="' + htmlEscape(full) + '" tabindex="-1">' + htmlEscape(label) + '</li>';
  }).join("");
  positionBreedDropdown(breedInput);
  breedDropdown.classList.remove("hidden");
  breedDropdown.classList.add("open");
  breedInput.classList.add("open");
  breedInput.setAttribute("aria-expanded", "true");
// mark the first option as the active one (tabindex=0) but do NOT move focus
  const first = breedDropdown.querySelector('li[role="option"]');
  if (first) first.tabIndex = 0;
}

function moveActive(delta) {
  const items = Array.from(breedDropdown.querySelectorAll('li[role="option"]'));
  if (!items.length) return;
  const idx = items.findIndex(el => el === document.activeElement);
  let next;
  if (idx === -1) {
    // no option focused yet (focus is in the input) – start at ends appropriately
    next = delta > 0 ? items[0] : items[items.length - 1];
  } else {
    next = items[(idx + delta + items.length) % items.length];
  }
  items.forEach(el => el.tabIndex = -1);
  next.tabIndex = 0;
  next.focus();
}

breedInput.addEventListener("keydown", (e) => {
  if (!breedDropdown.classList.contains("open")) return;
  if (e.key === "ArrowDown") { e.preventDefault(); moveActive(+1); }
  if (e.key === "ArrowUp")   { e.preventDefault(); moveActive(-1); }
  if (e.key === "Escape")    { e.preventDefault(); hideBreedDropdown(); }
  if (e.key === "Enter") {
    e.preventDefault();
    const li = breedDropdown.querySelector('li[role="option"][tabindex="0"]');
    if (li) li.click();
  }
});

// Keep keyboard nav active when focus is inside the list
breedDropdown.addEventListener("keydown", (e) => {
  if (!breedDropdown.classList.contains("open")) return;

  if (e.key === "ArrowDown") { e.preventDefault(); moveActive(+1); }
  if (e.key === "ArrowUp")   { e.preventDefault(); moveActive(-1); }
  if (e.key === "Escape")    { e.preventDefault(); hideBreedDropdown(); }

  if (e.key === "Enter") {
    e.preventDefault();
    const li = document.activeElement?.matches?.('li[role="option"]')
      ? document.activeElement
      : breedDropdown.querySelector('li[role="option"][tabindex="0"]');
    if (li) li.click();
  }
});

function hideBreedDropdown() {
  breedDropdown.classList.add("hidden");
  breedDropdown.classList.remove("open");
  breedInput.classList.remove("open");
  breedInput.setAttribute("aria-expanded", "false");
}

const onBreedInput = debounce(async () => {
   const sp = speciesSelect.value || "dog";
   const all = await fetchBreeds(sp);
   const matches = filterBreeds(breedInput.value, all);
   syncHiddenBreed();                 // keep hidden code in sync
   if (document.activeElement === breedInput) showBreedDropdown(matches);
 }, 150);
 breedInput.addEventListener("input", onBreedInput);

breedInput.addEventListener("focus", async () => {
  const sp = speciesSelect.value || "dog";
  const all = await fetchBreeds(sp);
  const matches = filterBreeds(breedInput.value, all);
  showBreedDropdown(matches);
});

breedInput.addEventListener("blur", () => {
  // Delay, and only hide if focus didn't move into the dropdown
  setTimeout(() => {
    if (!breedDropdown.contains(document.activeElement)) {
      hideBreedDropdown();
    }
  }, 150);
});

breedDropdown.addEventListener("mousedown", (e) => {
  // prevent blur before we set values
  e.preventDefault();
});

breedDropdown.addEventListener("click", (e) => {
  const li = e.target.closest("li[data-full]");
  if (!li) return;
  const full = li.getAttribute("data-full");
  breedInput.value = formatBreedLabel(full);
  breedHidden.value = full;
  clearError(breedInput);
  hideBreedDropdown();
});

document.addEventListener("click", (e) => {
  if (!breedDropdown.contains(e.target) && e.target !== breedInput) {
    hideBreedDropdown();
  }
});

    (async () => {
      try {
        await refreshBreeds();
      } catch (e) {
        console.error("[sp-reg] Preload error:", e);
      }
    })();

    // ---------- submit ----------
    function setSubmitting(isSubmitting) {
      submitBtn.disabled = isSubmitting;
      form.setAttribute("aria-busy", isSubmitting ? "true" : "false");
      submitBtn.textContent = isSubmitting ? "Fetching…" : "Register Now";
    }

    

function renderSuccessPage(plans, lead, quoteMeta) {
  var stray = document.getElementById('sp-breed-dropdown');
  if (stray) stray.remove();

  var petName = (lead && lead.pet_name) || (lead && lead.name) || "your pup";
  plans = Array.isArray(plans) ? plans : [];
  
  // -- DYNAMIC PAGE STATE UPDATE --
  // Morph the accordion header into a static success badge
  var pageTitle = document.getElementById('sp-dynamic-title');
  var accordionIcon = document.getElementById('sp-accordion-icon');
  var accordionContent = document.getElementById('sp-accordion-content');
  var accordionBtn = document.getElementById('sp-accordion-btn');

  if (pageTitle) pageTitle.innerHTML = "You're Registered!";
  if (accordionIcon) accordionIcon.style.display = "none"; // Hide the dropdown chevron
  if (accordionContent) accordionContent.style.maxHeight = null; // Force collapse
  if (accordionBtn) {
      accordionBtn.style.cursor = "default";
      accordionBtn.setAttribute("aria-expanded", "false");
  }
  
  // -- SOFT QUOTE PITCH --
  var softQuoteHtml = "";
  if (plans && plans.length > 0) {
    var bestPlan = plans[0]; 
    if (plans.length > 1 && Number(plans[1].monthly) < Number(plans[0].monthly)) {
        bestPlan = plans[1];
    }
    var monthly = (bestPlan.monthly != null) ? ("$" + Number(bestPlan.monthly).toFixed(2)) : "";
    var href = (bestPlan.apply_url) ? bestPlan.apply_url : "https://app.prudentpet.com/?promoCode=hiccup";
    
    softQuoteHtml = `
      <div style="margin-top: 2rem; padding: 1.25rem; border: 1px solid #e2e8f0; border-radius: 12px; background: #f8fafc; text-align: left;">
        <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 0.75rem;">
            <img src="https://cdn.shopify.com/s/files/1/0339/3110/0219/files/Hiccup-Pet-Insurance_Main-Logo.png?v=1761852118" style="height: 22px; width: auto;" alt="Hiccup Pet Insurance" />
            <span style="font-size: 0.8rem; font-weight: 700; color: #9C3B8C; background: #f5d7e7; padding: 3px 10px; border-radius: 99px;">Partner Perk</span>
        </div>
        <p style="font-size: 0.95rem; color: #475569; margin-bottom: 1rem; line-height: 1.4;">
          We found a customized health plan for <strong>${petName}</strong> starting at just <strong>${monthly}/mo</strong>.
        </p>
        <a id="sp-soft-quote-cta" href="${href}" target="_blank" rel="noopener" style="display: block; text-align: center; width: 100%; padding: 0.8rem; border: 2px solid #9C3B8C; color: #9C3B8C; border-radius: 8px; font-weight: 700; text-decoration: none; font-size: 1rem; transition: all 0.2s ease;">
          View ${petName}'s Quote
        </a>
      </div>
    `;
  }

  // -- SUCCESS SLIDE UI --
  var html = `
    <div class="sp-card sp-success" style="animation: fadeIn 0.5s ease-in-out; text-align: center; padding: 1.5rem;">
      <div class="sp-progress-container" style="margin-bottom: 2rem;">
        <div class="sp-progress-bar" style="width: 100%; background: #8DC642;"></div>
      </div>

      <h2 class="heading--primary" style="margin-bottom: 1rem; font-size: 1.75rem;">We're thrilled to have you and <strong>${petName}</strong> as part of the Snuggle Puppy family!</h2>
      
      <p class="sp-success__intro" style="margin-bottom: 1rem; font-size: 1.1rem; line-height: 1.5; color: #475569;">
         Our mission is to naturally relieve anxiety so you both can get back to enjoying life together.
      </p>
      
      <p class="sp-success__intro" style="margin-bottom: 2rem; font-size: 1.1rem; line-height: 1.5; color: #475569;">
        Your <em>No Sleepless Nights Promise</em> is now officially active.
      </p>

      <div style="background: #e5elf6; border-radius: 12px; padding: 1.5rem; border: 1px solid #d1dee6; text-align: center;">
        <h3 style="font-family: 'Tobi Pro', sans-serif; font-size: 1.35rem; margin: 0 0 0.5rem; color: #00A2D5;">Check Your Inbox!</h3>
        <p style="font-size: 1.05rem; color: #475569; margin-bottom: 0; line-height: 1.4;">
          We've just emailed you your <strong>free gift</strong>, along with our exclusive guide: <em>"5 Things Every Pet Parent Needs to Know."</em> Keep an eye out for it!
        </p>
      </div>

      ${softQuoteHtml}
    </div>
  `;

  root.innerHTML = html;

  // -- EVENT TRACKING --
  var softCta = root.querySelector('#sp-soft-quote-cta');
  if (softCta) {
    const hotUrl = API_ENDPOINT + "/hot-lead";
    const hotPayload = JSON.stringify({
      email: String(lead && lead.email || "").trim(),
      first_name: (lead && lead.first_name) || "",
      last_name:  (lead && lead.last_name)  || ""
    });
    
    softCta.addEventListener("click", function() {
      try {
        if (navigator.sendBeacon) {
          navigator.sendBeacon(hotUrl, new Blob([hotPayload], { type: "application/json" }));
        } else {
          fetch(hotUrl, { method: "POST", headers: { "Content-Type": "application/json" }, body: hotPayload, keepalive: true }).catch(() => {});
        }
      } catch(e) {}
    }, { once: true });
  }
}

function renderPlans(plans) {
      if (!Array.isArray(plans) || !plans.length) {
        results.innerHTML = '<div class="message message--background"><p>Sorry, something went wrong while processing. Please double-check your information and try again in a moment.</p></div>';
        return;
      }

      results.innerHTML = plans
        .slice(0, 2)
        .map(
          (p) =>
            '<div class="sp-plan-card">' +
            '<div class="sp-plan-head">' +
            "<h3>" +
            (p.name || "Plan") +
            "</h3>" +
            (p.annual_limit ? '<div class="sp-muted">Annual Limit: $' + Number(p.annual_limit).toLocaleString() + "</div>" : "") +
            "</div>" +
            '<div class="sp-plan-price">' +
            '<div class="sp-price">' +
            (p.monthly != null ? "$" + Number(p.monthly).toFixed(2) : "—") +
            "</div>" +
            '<div class="sp-muted">per month</div>' +
            "</div>" +
            '<div class="sp-plan-meta">' +
            (p.reimbursement != null ? '<div class="sp-muted">' + Number(p.reimbursement) + "% Reimbursement</div>" : "") +
            (p.deductible != null ? '<div class="sp-muted">$' + Number(p.deductible).toFixed(0) + " Deductible</div>" : "") +
            "</div>" +
            (p.apply_url
              ? '<a class="btn btn--primary btn--full-mobile" href="' +
                p.apply_url +
                '" target="_blank" rel="nofollow noopener">Open Quote</a>'
              : "") +
            "</div>"
        )
        .join("");
    }

    form.addEventListener("submit", async (e) => {
      track("reg_form_submit_attempt");
      e.preventDefault();
      results.innerHTML = "";
      clearAllErrors(form);

      let firstInvalid = null;

      
      // Required text fields
      const firstName = $("#sp-first-name", root);
      const lastName = $("#sp-last-name", root);
      const petName = $("#sp-pet-name", root);
      const consent = $("#sp-consent", root);

      if (firstName && !firstName.value.trim()) {
        showError(firstName, "First name is required");
        if (!firstInvalid) firstInvalid = firstName;
      }
      if (lastName && !lastName.value.trim()) {
        showError(lastName, "Last name is required");
        if (!firstInvalid) firstInvalid = lastName;
      }
      if (petName && !petName.value.trim()) {
        showError(petName, "Pet name is required");
        if (!firstInvalid) firstInvalid = petName;
      }

      // DOB required
      if (dobInput) {
        if (!dobInput.value) {
          showError(dobInput, "Pet date of birth is required");
          if (!firstInvalid) firstInvalid = dobInput;
        }
      }

      // Species required
      if (!speciesSelect.value) {
        showError(speciesSelect, "Please select a species");
        if (!firstInvalid) firstInvalid = speciesSelect;
      }

      // Consent required
      if (consent && !consent.checked) {
        showError(consent, "You must agree to receive updates to continue");
        if (!firstInvalid) firstInvalid = consent;
      }
// Email required + valid format
      if (emailInput) {
        const v = emailInput.value;
        if (!isValidEmail(v)) {
          showError(emailInput, "Please enter a valid email address");
          if (!firstInvalid) firstInvalid = emailInput;
        }
      }

      // DOB range (only if provided)
      if (dobInput && dobInput.value) {
        const d = new Date(dobInput.value + "T00:00:00");
        const min = new Date(dobInput.getAttribute("min"));
        const max = new Date(dobInput.getAttribute("max"));
        if (!(d instanceof Date) || isNaN(d.getTime()) || d < min || d > max) {
          showError(dobInput, "Please enter a valid date of birth");
          if (!firstInvalid) firstInvalid = dobInput;
        }
      }

      // ZIP must be exactly 5 digits
      if (zipInput) {
        const z = (zipInput.value || "").replace(/\D/g, "");
        if (z.length !== 5) {
          showError(zipInput, "Please enter a valid 5-digit ZIP code");
          if (!firstInvalid) firstInvalid = zipInput;
        }
      }

      // Gender required
      if (!genderSelect.value) {
        showError(genderSelect, "Please select your pet's gender");
        if (!firstInvalid) firstInvalid = genderSelect;
      }

      // Breed must map to canonical
      syncHiddenBreed();
      if (!breedHidden.value) {
        showError(breedInput, "Please choose a breed from the list");
        if (!firstInvalid) firstInvalid = breedInput;
      }

      if (firstInvalid) {
        firstInvalid.scrollIntoView({ behavior: "smooth", block: "center" });
        try { firstInvalid.focus({ preventScroll: true }); } catch {}
        return;
      }

      setSubmitting(true);

      try {
        const formData = new FormData(form);
        const lead = Object.fromEntries(formData.entries());
        lead.breed = lead.breed_code || lead.breed;

        // ZIP sanitize (5 digits)
        if (lead.zip) lead.zip = String(lead.zip).replace(/\D/g, "").slice(0, 5);

        // Normalize gender to "M"/"F"
        if (lead.gender) {
          const g = (lead.gender || "").toUpperCase();
          lead.gender = g.startsWith("F") ? "F" : g.startsWith("M") ? "M" : "";
        }

        // Honeypot
        const hp = root.querySelector("#sp-company");
        if (hp && hp.value) { return; }

      const payload = {
          lead,
          qr: Object.fromEntries(qs.entries()),
          listId: LIST_ID,
          siteId: SITE_ID
        };

        const res = await fetch(API_ENDPOINT, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });

        if (!res.ok) {
          let bodyText = await res.text();
          let details = "";
          try {
            const parsed = JSON.parse(bodyText);
            details = parsed.details || parsed.error || bodyText;
          } catch {
            details = bodyText;
          }
          console.error("Quote request failed:", res.status, details);
          track("reg_form_submit_error", { status: res.status, details: String(details).slice(0, 140) });
          results.innerHTML =
            '<div class="message message--background">' +
            "<p>Sorry, something went wrong while processing. Please double-check your information and try again in a moment.</p>" +
            '<pre class="sp-muted" style="white-space:pre-wrap;font-size:12px;">' +
            String(details).slice(0, 900) +
            "</pre>" +
            "</div>";
          return;
        }

        const data = await res.json();
        renderSuccessPage((data && data.plans) || [], lead, data || {});

// Smooth-scroll to the top of the new success content
requestAnimationFrame(() => {
  // pick a solid anchor in the newly rendered success view
  const anchor =
    root.querySelector('.sp-card.sp-success') ||  // the success wrapper
    root.querySelector('h2.heading--primary') ||  // fallback: heading
    root;                                         // final fallback

  try {
    const y = anchor.getBoundingClientRect().top + window.scrollY - 12;
    window.scrollTo({ top: y, behavior: "smooth" });
  } catch {}
});

        try {
          const pc = (data.plans || []).length;
          const price = ((data.plans || [])[0] || {}).monthly;
          track("reg_form_submit_success", { plan_count: pc, first_price: price });
        } catch {}
      } catch (err) {
        console.error(err);
        results.innerHTML = '<div class="message message--background"><p>Sorry, something went wrong while processing. Please double-check your information and try again in a moment.</p></div>';
      } finally {
        setSubmitting(false);
      }
    });
  } catch (err) {
    console.error("[sp-reg] Fatal init error:", err);
  }
})();